import axios from 'axios'
import { cancelHTTPRequests } from '@/services/utils'
import http from './webhook/httpconfig'
import AppWarn from '@/services/errors/app-warns'
import { generateHeaders } from './webhook/webhook'
import { getCdnBaseUrl } from './utils'

export default {
  async getAttachmentSizeByURL(url) {
    try {
      const response = await fetch(url, { method: 'HEAD' })
      if (response.ok) {
        const contentLength = response.headers.get('Content-Length')
        if (contentLength) {
          return parseInt(contentLength, 10)
        }
      }
    } catch (error) {
      console.error('Error getting image size:', error)
    }
  },

  async getPreSignedPostURL(data) {
    try {
      const response = await http.request({
        url: '/api/upload',
        method: 'post',
        headers: generateHeaders(),
        data,
        cancelToken: cancelHTTPRequests()
      })
      return response.data?.preSignedUrl
    } catch {
      throw new AppWarn({
        name: 'UploadError',
        message: 'Failed to generate pre-signed URL'
      })
    }
  },

  async getPreSignedDownloadUrl(data) {
    try {
      const response = await http.request({
        url: '/api/download',
        method: 'post',
        headers: generateHeaders(),
        data,
        cancelToken: cancelHTTPRequests()
      })
      return response.data?.preSignedUrl
    } catch {
      throw new AppWarn({
        name: 'UploadError',
        message: 'Failed to generate pre-signed download URL'
      })
    }
  },

  async getDownloadFile(data) {
    try {
      const response = await http.request({
        url: '/api/download/file',
        method: 'post',
        headers: generateHeaders(),
        data,
        responseType: 'blob',
        cancelToken: cancelHTTPRequests()
      })
      return response
    } catch {
      throw new AppWarn({
        name: 'UploadError',
        message: 'Failed to generate pre-signed download URL'
      })
    }
  },

  async getChatTranscript() {
    try {
      const response = await http.request({
        url: '/api/downloadTranscript',
        method: 'get',
        headers: {
          ...generateHeaders(),
          'x-cdn-url': getCdnBaseUrl()
        }, 
        cancelToken: cancelHTTPRequests()
      })
      return response
    }catch {
      throw new AppWarn({
        name: 'DownloadError',
        message: 'Failed to generate chatTranscript download URL'
      })
    }
  },

  async scanFileForMalware(file) {
    try {
      const formData = new FormData()
      formData.append('FILES', file)
      const response = await http.request({
        url: '/api/scan',
        method: 'post',
        headers: {
          ...generateHeaders(),
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
        cancelToken: cancelHTTPRequests()
      })
      const result = response.data
      if (!result.success || !result.data || !result.data.result) {
        throw new Error('Invalid response format from scan service')
      }
      const fileScanResult = result.data.result[0]
      return {
        name: fileScanResult.name,
        isInfected: fileScanResult.is_infected,
        viruses: fileScanResult.viruses
      };
    } catch {
      throw new AppWarn({
        name: 'ScanError',
        message: 'Failed to scan file for malicious content'
      });
    }
  },


  async uploadFileToS3ByPreSignedURL(file, uploadUrl, uploadParams) {
    var formData = new window.FormData()
    for (let param in uploadParams) {
      formData.append(param, uploadParams[param])
    }
    formData.append('acl', 'public-read')
    formData.append('Content-Type', file.type)
    formData.append('file', file)
    try {
      const responsePromise = axios.post(uploadUrl, formData)
      return responsePromise
    } catch (e) {
      throw new AppWarn({
        name: 'UploadError',
        message: `Error in uploading to pre-signed url. ${e.message}`
      })
    }
  }
}
